import { createTokensFromScale } from '../../utils/createTokensFromScale';
export const defaultBorderRadiusScale = {
    prefix: 'twist-core-border-radius',
    steps: {
        base: { size: 3, unit: 'px' },
        1: { multiplier: 1 },
        2: { multiplier: 2 },
        3: { multiplier: 3 },
        4: { multiplier: 4 },
        5: { multiplier: 5 },
        6: { multiplier: 6 },
        8: { multiplier: 8 },
        10: { multiplier: 10 },
        12: { multiplier: 12 },
        15: { multiplier: 15 },
        20: { multiplier: 20 },
        round: { size: 1000, unit: 'px' }
    }
};
// generates the following tokens:
// const defaultBorderRadiusTokens = {
//   'twist-core-border-radius-base': '3px',
//   'twist-core-border-radius-1': 'var(--twist-core-border-radius-base)',
//   'twist-core-border-radius-2': 'calc(2 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-3': 'calc(3 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-4': 'calc(4 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-5': 'calc(5 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-6': 'calc(6 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-8': 'calc(8 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-10': 'calc(10 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-12': 'calc(12 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-15': 'calc(15 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-20': 'calc(20 * var(--twist-core-border-radius-base))',
//   'twist-core-border-radius-round': '1000px'
// }
export const defaultBorderRadiusTokens = createTokensFromScale(defaultBorderRadiusScale);
